import React from 'react';
import { IconButton, Stack, Typography } from '@mui/material';
import { Add, Remove } from '@mui/icons-material';
import { blue, grey } from '@mui/material/colors';
import { SectionHeaderProps } from '../../types';

export const SectionHeader = ({ title, isCollapsed, withCollapsing = false, onChangeCollapse }: SectionHeaderProps) => {
  const handleChange = () => {
    onChangeCollapse?.(!isCollapsed);
  };

  return (
    <Stack
      sx={{
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: '0.25rem',
        padding: '0.3rem 0.5rem',
        justifyContent: 'flex-start',
        background: withCollapsing ? blue['50'] : grey['200'],
      }}
    >
      {withCollapsing && (
        <IconButton size="small" onClick={handleChange}>
          {!isCollapsed ? (
            <Add sx={{ color: 'black', fontSize: '1rem' }} />
          ) : (
            <Remove sx={{ color: 'black', fontSize: '1rem' }} />
          )}
        </IconButton>
      )}

      <Typography component="span" variant="subtitle2">
        {title}
      </Typography>
    </Stack>
  );
};
